import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Buildings, ArrowRight, X } from '@phosphor-icons/react';

/**
 * Blocking modal shown when a user tries to execute a worker
 * but hasn't completed their business profile setup.
 */
export default function SetupRequiredModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm" data-testid="setup-required-modal">
      <div className="bg-[#0F1318] border border-[rgba(255,255,255,0.08)] rounded-2xl p-6 max-w-sm w-full mx-4 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-[#4B5563] hover:text-white transition-colors"
          data-testid="setup-required-close"
        >
          <X size={16} />
        </button>

        <div className="w-12 h-12 rounded-xl bg-[rgba(99,102,241,0.1)] flex items-center justify-center mb-4">
          <Buildings size={24} className="text-[#818CF8]" />
        </div>

        <h3 className="text-lg font-bold text-white mb-2">Finish setup to activate this worker</h3>
        <p className="text-sm text-[#7D8896] mb-5">
          Add your business details so this works properly. It takes about 2 minutes.
        </p>

        <button
          onClick={() => navigate('/workers')}
          data-testid="setup-required-cta"
          className="w-full flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-[#6366F1] text-white text-sm font-semibold hover:bg-[#5558E6] transition-colors"
        >
          Go to My Workers <ArrowRight size={14} />
        </button>
      </div>
    </div>
  );
}
